import { PortfolioTokensAndUnderlyingYieldBearingAssetsListSection } from '@/components';
import { FC } from 'react';
interface Props {
  noOfItemsToShow: number;
  showShortList?: boolean;
}
const PortfolioAssetsList: FC<Props> = ({
  noOfItemsToShow,
  showShortList = false,
}) => {
  return (
    <PortfolioTokensAndUnderlyingYieldBearingAssetsListSection
      noOfItemsToShow={noOfItemsToShow}
      showSection={false}
      showShortList={showShortList}
    />
  );
};
export default PortfolioAssetsList;
